import CancelIcon from '@mui/icons-material/Cancel';
import { ListItemIcon, ListItemText } from '@mui/material';
import FormattedMessage from 'features/i18n/FormattedMessage';

export const EmptyTargetAudienceMenuItemContent = () => {
  return (
    <>
      <ListItemIcon>
        <CancelIcon />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage id="target_audience.select.empty_menu_item" />
      </ListItemText>
    </>
  );
};
